import { render, staticRenderFns } from "./CreatePart3.vue?vue&type=template&id=09c16ab9&"
import script from "./CreatePart3.vue?vue&type=script&lang=js&"
export * from "./CreatePart3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports